const logger = (store) => (next) => (action) => {
  console.log(action.type);
  // console.log(store.getState().settlements.edits);

  next(action);
};

export default logger;
